module.exports = __webpack_public_path__ + "img/telegram.e746ae41.png";